import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const emitToasterMsg = (type, title, message) => {
	toast.configure();
	const autoCloseTimer = 3000;

	const toasterBody = () => {
		return (
			<div className="abs-toaster-container" >
				<div className="title" style={{ fontSize: '14px', whiteSpace: 'pre-line' }}>{title}</div>
				<div className="message" style={{ whiteSpace: 'pre-line' }}>
					{Array.isArray(message)
						? message.map((msg, index) => (
							<div key={index}>{msg}</div>
						))
						: message}
				</div>
			</div>
		);
	};

	switch (type) {
		case "success":
			toast.success(toasterBody, {
				autoClose: autoCloseTimer,
			});
			break;
		case "error":
			toast.error(toasterBody, {
				autoClose: autoCloseTimer,
			});
			break;
		default:
			break;
	}
};
